<nav class="navbar navbar-expand-lg navbar-dark">
    <a class="navbar-brand" href="#">KeepItGreen4U</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item active">
          <a class="nav-link" href="#">HOME</a>
        </li> 
        <li class="nav-item active">
          <a class="nav-link" href="contact">CONTACT</a>
        </li> 
        <li class="nav-item active">
          <a class="nav-link" href="about">ABOUT</a>
        </li> 
      </ul>
    </div>
  </nav>
